import React from "react";
import { useHistory } from "react-router-dom";
import { X } from "phosphor-react";
import PropTypes from "prop-types";
import Badge from "components/elements/Badge";
import "./index.scss";

const EMToolBar = ({ step }) => {
  const history = useHistory();
  const goBack = () => {
    history.push("/farms");
    window.location.reload();
  };
  return (
    <>
      <section className="transaction-headings">
        <div className="transaction-nav">
          <span
            className="link"
            aria-hidden
            onKeyDown={() => goBack()}
            onClick={() => goBack()}
          >
            <X size={20} color="#292b33" weight="bold" />
          </span>
          <h1 data-testid="title" className="title">
            Book Rapid-EM™ Machine
          </h1>
        </div>
        <div className="stepper-area">
          <div className="step">
            <Badge style={step !== 1 ? "outlined" : "contained"} number="1" />
            <p className="label">Book</p>
          </div>
          <div className="step">
            <Badge style={step !== 2 ? "outlined" : "contained"} number="2" />
            <p className="label">Review</p>
          </div>
          <div className="step">
            <Badge style={step !== 3 ? "outlined" : "contained"} number="3" />
            <p className="label">Payment</p>
          </div>
        </div>
      </section>
      <div className="transaction-sticky">
        <p className="text">Do you want to book outside of Australia? </p>
        <a className="link" href="mailto:support@datafarming.com">
          Contact Us
        </a>
      </div>
    </>
  );
};

EMToolBar.propTypes = {
  step: PropTypes.number,
};

EMToolBar.defaultProps = {
  step: 1,
};

export default EMToolBar;
